import type { ListOption } from '../GenericBloc/GenericShortListFilter/GenericShortListDropdown';
import { BuddyIcon } from './icons/BuddyIcon';

export enum FEEDBACK_TYPE {
  HATE = '0',
  DISLIKE = '1',
  NEUTRAL = '2',
  LIKE = '3',
  LOVE = '4',
}

export const FEEDBACK_FILTER_OPTIONS: ListOption<FEEDBACK_TYPE>[] = [
  { value: FEEDBACK_TYPE.LOVE, label: 'Love', content: <BuddyIcon score={4} size="s" /> },
  { value: FEEDBACK_TYPE.LIKE, label: 'Like', content: <BuddyIcon score={3} size="s" /> },
  { value: FEEDBACK_TYPE.NEUTRAL, label: 'Neutral', content: <BuddyIcon score={2} size="s" /> },
  { value: FEEDBACK_TYPE.DISLIKE, label: 'Dislike', content: <BuddyIcon score={1} size="s" /> },
  { value: FEEDBACK_TYPE.HATE, label: 'Hate', content: <BuddyIcon score={0} size="s" /> },
];
